import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import PortalIdParser from 'PortalIdParser';
import { ecosystemAppClient, ecosystemPublicClient } from '../../common/clients/ecosystemClient';
import { TYPEAHEAD_SEARCH_RESULTS_LIMIT } from '../../constants/search';
import AppSearchBarResult from '../components/AppSearchBarResult';
// TODO refactor
export function getAppMarketplaceUrl(appContext) {
  let urlRoot;

  if (appContext === 'app') {
    urlRoot = `${getFullUrl('app')}/ecosystem/${PortalIdParser.get()}`;
  } else {
    urlRoot = getFullUrl('ecosystem', {
      hubletOverride: 'na1'
    });
    const lang = getLang();

    switch (lang) {
      case 'de':
      case 'es':
      case 'fr':
      case 'ja':
      case 'pt':
        {
          urlRoot += `/${lang}`;
          break;
        }

      default:
        break;
    }
  }

  return `${urlRoot}/marketplace/apps`;
}
export const VIEW_ALL_APPS = '__VIEW_ALL_APPS__';
export function useAppSearchBarQuery({
  appContext = 'app',
  grouped = false,
  limit = TYPEAHEAD_SEARCH_RESULTS_LIMIT,
  query = {}
} = {}) {
  const fetcher = useCallback(input => {
    const client = appContext === 'public' ? ecosystemPublicClient : ecosystemAppClient;
    const response = client.post('apps/search', {
      data: {
        language: getLang(),
        queries: [Object.assign({}, query, {
          length: limit,
          search: input
        })]
      }
    });
    return response.then(({
      results: [{
        items,
        total
      }]
    }) => {
      const options = items.map(item => {
        const {
          category,
          companyName,
          iconUrl,
          name,
          offeringId,
          slug,
          tagline
        } = item;
        return {
          dropdownText: /*#__PURE__*/_jsx(AppSearchBarResult, {
            category: category,
            companyName: companyName,
            iconUrl: iconUrl,
            name: name,
            tagline: tagline
          }),
          href: `${getAppMarketplaceUrl(appContext)}/_detail/${slug}`,
          item,
          linkUse: 'unstyled',
          text: name,
          value: `app::${offeringId}`,
          category: item.category,
          slug
        };
      });

      if (total > limit) {
        options.push({
          href: `${getAppMarketplaceUrl(appContext)}/all-categories?eco_search=${input}`,
          text: I18n.text('ecosystemMarketplaceCore.apps.appSearchBarViewAll', {
            total
          }),
          value: VIEW_ALL_APPS
        });
      }

      return options;
    }).then(options => grouped ? [{
      text: I18n.text('ecosystemMarketplaceCore.apps.appSearchBarGroupLabel'),
      options
    }] : options);
  }, [appContext, grouped, limit, query]);
  return {
    fetcher
  };
}